import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.css']
})
export class SidemenuComponent implements OnInit {

	loading: boolean = false;
	email: string = "";
	credits: number = 0;
	loadingUserInfo: boolean = false;
	queryParams: any = {};

	@Output() sideMenuEvent = new EventEmitter<any>();

	constructor(public router: Router, public activatedRoute: ActivatedRoute, public cwsms: CWSMSAPIService, public translate: TranslateService) {
		this.activatedRoute.queryParams.subscribe( (params) => {
			this.queryParams = params;
		});
	}

	ngOnInit() {
		this.getUser();

		this.cwsms.currentMessage.subscribe(message => {
			if (message == "sidemenu:updateUser") {
				this.getUser();
			}
		});
	}

	changeLanguage(lang) {
		var url = window.location.href.toString().split("?")[0];
		window.location.href = url+"?lang="+lang;
	}

	getUser() {
		this.loadingUserInfo = true;
		this.cwsms.get('/user', (err, data) => {
			this.loadingUserInfo = false;
			if (err) {
				console.log(err);
				if ("message" in err || "error" in err) {
					this.router.navigate([''], {
						queryParams: {
							error: err.error.message
						}
					});
				} else {
					this.router.navigate([''], { preserveQueryParams: true });
				}
			} else {
				console.log(data);
				this.sideMenuEvent.emit({userData:data});
				this.email = data.email.S;
				this.credits = parseFloat(data.credits.N);

				if (this.queryParams["lang"]) {
					this.translate.use(this.queryParams["lang"]);
				} else if ("billingInfo" in data && "M" in data.billingInfo) {
					if (data.billingInfo.M.country.S.toLowerCase().startsWith("norway")) {
						this.translate.use('no');
					}
				}
				
/*
				if (this.credits > 0 && !("billingInfo" in data)) {
					this.router.navigate(['billing']);
				}
				*/
			}
		});
	}

	home() {
		this.router.navigate(['home'], { preserveQueryParams: true });
	}

	sendSMS() {
		this.router.navigate(['send'], { preserveQueryParams: true });
	}

	messageLog() {
		this.router.navigate(['log'], { preserveQueryParams: true });
	}

	api() {
		this.router.navigate(['api'], { preserveQueryParams: true });
	}

	billing() {
		this.router.navigate(['billing'], { preserveQueryParams: true });
	}

	buy() {
		this.router.navigate(['buy'], { preserveQueryParams: true });
	}

	logout() {
		this.loading = true;
		this.cwsms.get('/auth/logout', (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				sessionStorage.clear();
				this.router.navigate([''], { preserveQueryParams: true });
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/sidemenu/sidemenu.component.ts